<section class="data-table font-xs">
  @if (tableData.length > 0) {
    <div class="data-header-row">
      @if (hasAnyNewDocuments) {
        <span
          class="new-badge-spacing-span font-secondary-color font-xs data-header-item"
        ></span>
      }
      <span
        [ngClass]="{
          'font-secondary-color font-xs data-header-item ': true,
          'data-header-name-expanded': !hasAnyNewDocuments,
        }"
        >{{
          "features.product-overview.productDocumentsParams.documentName"
            | translate
        }}</span
      >
      <span class="font-secondary-color font-xs data-header-item">{{
        "features.product-overview.productDocumentsParams.documentLanguage"
          | translate
      }}</span>
      <span class="font-secondary-color font-xs data-header-item">{{
        "features.product-overview.productDocumentsParams.documentFormat"
          | translate
      }}</span>
      <span class="font-secondary-color font-xs data-header-item">{{
        "features.product-overview.productDocumentsParams.documentSize"
          | translate
      }}</span>
      @if (isDocumentIDOnForCurrentDocument()) {
        <span
          class="font-secondary-color font-xs data-header-item data-header-document-id"
          >{{
            "features.product-overview.productDocumentsParams.documentID"
              | translate
          }}</span
        >
      }
      <span class="font-secondary-color font-xs data-header-item"></span>
    </div>
  }
  @for (tableData of tableData; track tableData.id) {
    <claas-data-document-row
      [newBadge]="tableData.new"
      [name]="tableData.name"
      [language]="tableData.language"
      [format]="tableData.format"
      [size]="tableData.size"
      [id]="tableData.id"
    ></claas-data-document-row>
  }
</section>
